import { render, staticRenderFns } from "./AccessoriesTree.vue?vue&type=template&id=1249f890&scoped=true&"
import script from "./AccessoriesTree.vue?vue&type=script&lang=js&"
export * from "./AccessoriesTree.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesTree.vue?vue&type=style&index=0&id=1249f890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249f890",
  null
  
)

export default component.exports